import React, { useContext, useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import {RegistryContext} from "../../../contexts/RegistryContext";
import PartiesSearchInput from "../../parties/searchInput";
import { Input } from "antd";

const Counterpart = ({isReconciliationForm, isInFilter, isSave, requestBody, setRequestBody}) => {
  const registryStore = useContext(RegistryContext);

  const [partySelected, setPartySelected] = useState({});
  const [descriptionError, setDescriptionError] = useState(false);
  const [taxIdError, setTaxIdError] = useState(false);
  const [vatNumberError, setVatNumberError] = useState(false);

  const placeholderTaxId = useIntl().formatMessage({ id: "deadlines.pages.create.fiscalCodePlaceholder"});
  const placeHolderVatNumber = useIntl().formatMessage({ id: "deadlines.pages.create.deadlinePIVAPlaceholder" });

  useEffect(() => {
    
    if (!descriptionError && !taxIdError && !vatNumberError) return;
    // if (!document.querySelector(".errorOccurs")) return;
    // faccio scrollare al primo elemento in errore
    document.querySelector(".errorOccurs")?.scrollIntoView();
  }, [descriptionError, taxIdError, vatNumberError]);
  
  useEffect(() => {   
    if (!isSave) {
      setDescriptionError(false);
      setTaxIdError(false);
      setVatNumberError(false);
    } else {      
      if (requestBody.scope !== "fiscal_social_security"){
        if (!partySelected.description)  setDescriptionError(true);
        if (!partySelected.taxId)  setTaxIdError(true);
        if (!partySelected.vatNumber)  setVatNumberError(true);
      }
    }    
  }, [isSave]);
    
  return (
    <div style={{ marginTop: isReconciliationForm ? "32px" : "64px" }}>
      <div className="add-deadline-section">
        <FormattedMessage id="generic.counterpart" />
      </div>
      <div className="containerInputs">
        <div data-testid = "container-description" className={`greyInput ${ descriptionError ? "errorOccurs" : ""}` } style={{marginRight: "76px"}} >
          <div className="labelDialogContent">
            <FormattedMessage
              id={
                !isInFilter
                  ? "deadlines.pages.create.deadlineCounterpart"
                  : "deadlines.reconciliation.searchCounterpart"
              }
            />
          </div>
          <PartiesSearchInput
            data-testid = "party-description"
            disabled={requestBody.scope === "fiscal_social_security"}
            getPopupContainer={trigger => trigger.parentNode}
            registryStore={registryStore}                  
            selected={
              {
                id: partySelected?.id,
                description: requestBody.scope === "fiscal_social_security" ? "Erario" : partySelected?.description,
                taxId: partySelected?.taxId || null,
                vatNumber: partySelected?.vatNumber || null
              }}              
            width={"100"}
            source="client"
            onSelect={party => {
              const partyTaxid = party?.identifiers?.find(el => el.type === "TAX_ID")?.value ;
              const partyVatNumber = party?.identifiers?.find(el => el.type === "VAT_NUMBER")?.value;                     
              setPartySelected({
                id: party?.id,
                description: party?.description || party?.target?.value,
                taxId: partyTaxid || null,
                vatNumber: partyVatNumber || null
              });            
            
              setRequestBody({
                ...requestBody,
                counterpart: {
                  ...requestBody.counterpart,
                  description: party?.description || party?.target?.value,
                  taxId: partyTaxid || null,
                  vatNumber: partyVatNumber || null
                }
              });
          
            }}
            onClear={() => {
              /*
          setSelectedContact({
            id: null,
            name: null,
            vatNumber: null,
            taxId: null
          });
          */
            }}
            value={""/* selectedContact?.name */}
            placeholder={""/* useIntl().formatMessage({ id: obj.label }) */}
            customStyles={{}/* customStyles */}
            label={""/* seIntl().formatMessage({ id: obj.label }) + (obj.required ? " *" : "") */}
          />        
        </div>
        {
          (isReconciliationForm || (!isReconciliationForm && requestBody.scope !== "fiscal_social_security" && partySelected?.description)) &&
      <div className={"doubleCols"}>
        <div data-testid = "container-taxId" style={{marginRight: "38px"}} className={`greyInput ${ taxIdError ? "errorOccurs" : ""}` } >
          <div className="labelDialogContent">
            <FormattedMessage id="deadlines.pages.create.fiscalCode" />
          </div>
          <div className="inputCustom">
            <Input
              data-testid = "party-taxid"
              value={partySelected.taxId ? partySelected.taxId : ""}
              placeholder={placeholderTaxId}
              onChange={(e) => {
                if (partySelected.taxId !== e.target.value){
                  setPartySelected({
                    ...partySelected,
                    taxId: e.target.value
                  });            
                  
                  setRequestBody({
                    ...requestBody,
                    counterpart: {
                      ...requestBody.counterpart,                     
                      taxId: e.target.value
                    }
                  });
                }
              }}
            />
          </div>
        </div>
        <div data-testid = "container-vatNumber" style={{marginRight: "38px"}} className={`greyInput ${ vatNumberError ? "errorOccurs" : ""}` } >
          <div className="labelDialogContent">
            <FormattedMessage id="generic.counterpartPIVA" /> *
          </div>
          <div className="inputCustom">
            <Input
              data-testid = "party-vatNumber"
              value={partySelected.vatNumber ? partySelected.vatNumber : ""}
              placeholder={placeHolderVatNumber}
              onChange={(e) => {                
                if (partySelected.vatNumber !== e.target.value){
                  setPartySelected({
                    ...partySelected,                    
                    vatNumber: e.target.value
                  });            
                    
                  setRequestBody({
                    ...requestBody,
                    counterpart: {
                      ...requestBody.counterpart,                                           
                      vatNumber: e.target.value
                    }
                  });
                }
              }}
            />
          </div>
        </div>
      </div>
        }
      </div>
    </div>
  );
};

export default Counterpart;